"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "systemFromInfo",
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};